export enum OutfitTypeEnum {
  ORIGINAL = 0,
  SPLIT = 1,
}
